import { RecognitionBadge } from "@/components/recognition-badge/RecognitionBadge.tsx";
import { RecognitionActionsMenu } from "@/pages/settings/recognitions/widgets/RecognitionActionsMenu.tsx";
import { ApiRecognition } from "@/types/recognitions/recognition.types.ts";
import { Button, Modal, ModalProps, Title, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface RecognitionPreviewModalProps extends ModalProps {
  recognition: ApiRecognition;
}

export function RecognitionPreviewModal({ recognition, ...props }: RecognitionPreviewModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const { id } = props;

  return (
    <Modal
      {...props}
      title={t("recognition:view_title")}
      withCloser
      headerActionsSlot={
        <RecognitionActionsMenu
          recognition={recognition}
          onBeforeAction={() => close(id)}
          asButton
        />
      }
      actions={
        <Button size={"lg"} className={"w-full"} onClick={() => close(id)}>
          {t("common:ok")}
        </Button>
      }
    >
      <RecognitionBadge template={recognition} size={"lg"} />
      <Title
        size={"lg"}
        paddingTop
        paddingBottom
        header={recognition.title}
        caption={recognition.description}
      />
    </Modal>
  );
}
